import { Button } from '@mui/base/Button';

export default function BaseButton(props) {
  const { color, label, onClick, size, isDisabled } = props;
  return (
    <Button onClick={onClick} disabled={isDisabled} className={`base-btn ${color ? color : ''} ${size ? size : ''}`}><p>{label}</p></Button>
  )
}